import { render } from "./HeroiconsOutlineRss.vue?vue&type=template&id=6fffc871"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineRss.vue"]])

export default __exports__